module.exports = __webpack_public_path__ + "static/media/food_1.e8a06cdd.jpeg";